import { render } from "./top-nav-holder.component.vue?vue&type=template&id=dc9c0c98&ts=true"
import script from "./top-nav-holder.component.vue?vue&type=script&lang=ts"
export * from "./top-nav-holder.component.vue?vue&type=script&lang=ts"

import "./top-nav-holder.component.vue?vue&type=style&index=0&id=dc9c0c98&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__